import {
  IonButton,
  IonContent,
  IonIcon,
  IonModal,
  IonNote,
  IonPage,
  IonPopover,
  IonRouterLink,
  IonToast,
} from "@ionic/react";
import Footer from "../Slides/Footer";
import { LandingHeader } from "../Slides/Landing";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";
import {
  IonInput,
  IonItem,
  IonSpinner,
  IonText,
  IonCheckbox,
  IonLabel,
} from "@ionic/react";
import { DEFAULT_HOME_PATH } from "../../utils/constents";
import "./auth.css";
import { SERVER_URL } from "../../api/client";
import axios from "axios";

import { Link, Redirect } from "react-router-dom";
import { IonAlert } from "@ionic/react";
import { signUp } from "../../redux/actions/currentProfileActions";
import {
  FaCanadianMapleLeaf,
  FaCheck,
  FaEnvelope,
  FaEyeSlash,
  FaRegEye,
} from "react-icons/fa";
import { lockClosedOutline, mailOutline, personOutline } from "ionicons/icons";
import { useEffect } from "react";
import { CanadianButton } from "../../ui-components/CanadianButton";
const SignupForm = () => {
  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,4}$/;

  // function validateEmail(value) {
  //   return emailRegex.test(value);
  // }
  const [ageConfirmed, setAgeConfirmed] = useState(false);
  const [formError, setFormError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [showInviteAlert, setShowInviteAlert] = useState(false);
  const [resendTimer, setResendTimer] = useState(0); // 0 means button is active
  const [isResending, setIsResending] = useState(false); // For loading state
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const { data, loading, errors } = useSelector(
    (state) => state.currentProfile,
  );

  const dispatch = useDispatch();
  // --- Inside SignupForm component ---

  const { t } = useTranslation();
  // Timer Logic: Decrement timer every second if it's running
  useEffect(() => {
    let interval = null;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  const handleFinalSubmit = () => {
    if (!ageConfirmed) {
      setFormError("You must confirm your age to continue.");
      return;
    }

    setFormError("");
    setShowInviteAlert(false);

    const emailTrimmed = (email || "").trim().toLowerCase();
    const usernameTrimmed = (username || "").trim();

    const formData = {
      email: emailTrimmed,
      username: usernameTrimmed,
      password,
    };

    dispatch(signUp(formData)).then((res) => {
      const response = res.payload;
      if (
        response &&
        (response.status === 200 ||
          response.status === 201 ||
          (response.email && response._id))
      ) {
        window.location.href = "/verification";
      }
    });
  };
  const handleResendVerification = async () => {
    if (resendTimer > 0 || isResending) return;

    setIsResending(true);

    try {
      // Replace with your actual backend URL
      await axios.post(`${SERVER_URL}/profile/resend-verification`, {
        email: email,
      });

      setToastMessage("Email sent! Please check your inbox.");
      setShowToast(true);
      setResendTimer(60); // Start 60 second cooldown
    } catch (error) {
      if (error.response && error.response.status === 429) {
        // If backend says "Wait X seconds", we catch it here
        setToastMessage(error.response.data.message);
        setResendTimer(60); // Sync frontend timer with backend rule
      } else {
        setToastMessage("Failed to resend email. Please try again.");
      }
      setShowToast(true);
    } finally {
      setIsResending(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError(null);

    const emailTrimmed = (email || "").trim().toLowerCase();
    const usernameTrimmed = (username || "").trim();

    if (!emailTrimmed || !usernameTrimmed || !password) {
      setFormError(
        "Please fill out all required fields (username, email, password).",
      );
      return;
    }

    setShowInviteAlert(true);
  };

  const isStandalonePwa = () => {
    if (typeof window === "undefined") {
      return false;
    }
    const mediaStandalone =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(display-mode: standalone)").matches;
    const iosStandalone =
      typeof window.navigator !== "undefined" &&
      "standalone" in window.navigator &&
      window.navigator.standalone;
    const launchedFromAndroidApp =
      typeof document !== "undefined" &&
      typeof document.referrer === "string" &&
      document.referrer.startsWith("android-app://");
    return Boolean(mediaStandalone || iosStandalone || launchedFromAndroidApp);
  };

  const openExternal = (url) => {
    if (typeof window === "undefined" || !isStandalonePwa()) {
      return false;
    }
    try {
      const constructedUrl = new URL(url, window.location.origin);
      constructedUrl.searchParams.set("fromApp", "1");
      window.location.assign(constructedUrl.toString());
      return true;
    } catch (error) {
      return false;
    }
  };

  const handleClick = (event, url) => {
    if (openExternal(url)) {
      event.preventDefault();
    }
  };
  const openMailApp = () => {
    if (!email) return; // Safety check

    const domain = email.split("@")[1];
    let url = "";

    // Smart Detection
    if (domain.includes("gmail")) {
      url = "https://mail.google.com";
      // On Android/iOS, this URL often triggers the native Gmail app to open
    } else if (
      domain.includes("outlook") ||
      domain.includes("hotmail") ||
      domain.includes("live")
    ) {
      url = "https://outlook.live.com";
    } else if (domain.includes("yahoo")) {
      url = "https://mail.yahoo.com";
    } else if (domain.includes("icloud")) {
      url = "https://www.icloud.com/mail";
    } else {
      // Fallback for custom domains or unknown providers
      // We use 'mailto:' which opens the default mail app,
      // though it usually opens a "Compose" window.
      url = "mailto:";
    }

    // '_system' is crucial in Ionic to leave the app and open the external browser/app
    window.open(url, "_system");
  };

  if (data) {
    return <Redirect to={DEFAULT_HOME_PATH} />;
  }

  return (
    <form className="auth-form-container" onSubmit={handleSubmit}>
      <IonItem>
        <IonInput
          className="auth-input"
          // label={t("email")}
          // labelPlacement=""
          placeholder={t("emailPlaceholder")}
          type="email"
          name="email"
          required
          value={email}
          onIonChange={(e) => setEmail(e.detail.value || "")}
          onIonBlur={() => setEmail((email || "").trim().toLowerCase())}
          // fill="outline"
        >
          <IonIcon slot="start" icon={mailOutline} aria-hidden="true"></IonIcon>
        </IonInput>
      </IonItem>
      <IonItem>
        <IonInput
          className="auth-input"
          // label={t("username")}
          // labelPlacement="floating"
          placeholder={t("usernamePlaceholder")}
          name="username"
          required
          value={username}
          onIonChange={(e) => setUsername(e.detail.value || "")}
          onIonBlur={() => setUsername((username || "").trim())}
          // fill="outline"
        >
          <IonIcon
            slot="start"
            icon={personOutline}
            aria-hidden="true"
          ></IonIcon>
        </IonInput>
      </IonItem>
      {/* Password with eye toggle */}
      <IonItem>
        <IonInput
          className="auth-input"
          // label={t("password")}
          // labelPlacement="floating"
          placeholder={t("passwordPlaceholder")}
          type={showPassword ? "text" : "password"}
          name="password"
          required
          value={password}
          onIonChange={(e) => setPassword(e.detail.value || "")}
          // fill="outline"
        >
          <IonIcon
            slot="start"
            icon={lockClosedOutline}
            aria-hidden="true"
          ></IonIcon>
        </IonInput>
        <span
          onClick={() => setShowPassword(!showPassword)}
          style={{
            position: "absolute",
            right: "20px",
            top: "70%",
            transform: "translateY(-70%)",
            cursor: "pointer",
            zIndex: 10,
          }}
        >
          {showPassword ? <FaRegEye size={18} /> : <FaEyeSlash size={18} />}
        </span>
      </IonItem>

      {/* {formError && (
        <IonText color="danger">
          <p
            style={{
              margin: "0.5rem 2rem",
              fontSize: "14px",
              color: "#ff0000",
            }}
          >
            {formError}
          </p>
        </IonText>
      )} */}
      {formError && (
        <div className="error-message-box">
          <p className="error-text">
            {/* If the message contains \n, replace it with <br/> */}
            {formError.split("\n").map((line, i) => (
              <span key={i}>
                {line}
                <br />
              </span>
            ))}
          </p>
        </div>
      )}
      {/* {errors && errors[0]?.msg && (
        <div className="error-message-box">
          <p className="error-text">{errors[0].msg}</p>
        </div>
      )} */}
      {errors && errors[0]?.msg && (
        <div className="error-message-box">
          <p className="error-text">
            {errors[0].msg === "This user is already exist"
              ? "This account is already registered. Please sign in."
              : errors[0].msg}
          </p>
        </div>
      )}
      <p style={{ fontSize: "12px", margin: "10px 0", textAlign: "center" }}>
        {t("footerTitle")}{" "}
        <a
          onClick={(event) =>
            handleClick(event, "https://loonlog.ca/terms-of-service")
          }
          href="https://loonlog.ca/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "underline" }}
        >
          {t("footer.terms")}
        </a>{" "}
        &{" "}
        <a
          href="https://loonlog.ca/privacy-policy"
          onClick={(event) =>
            handleClick(event, "https://loonlog.ca/privacy-policy")
          }
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "underline" }}
        >
          {t("footer.privacy")}
        </a>
        .
      </p>
      <CanadianButton type="submit" className="auth-submit-button">
        {loading ? t("loading") : t("signup2")}
      </CanadianButton>
      <p className="auth__form__redirect poppins" style={{ fontSize: "12px" }}>
        {t("haveAccount")} <Link to="/signin">{t("signin")}</Link>
      </p>

      <IonPopover
        isOpen={showInviteAlert}
        onDidDismiss={() => setShowInviteAlert(false)}
        alignment="center"
        className="custom-popover"
      >
        <div className="popover-container">
          {/* Age Confirmation Group */}
          <div>
            <IonItem lines="none" className="ion-no-padding">
              <IonCheckbox
                slot="start"
                checked={ageConfirmed}
                onIonChange={(e) => setAgeConfirmed(e.detail.checked)}
              />
              <IonLabel
                className="ion-text-wrap"
                style={{ marginLeft: "10px" }}
              >
                I confirm I am 13 years of age or older.
              </IonLabel>
            </IonItem>
          </div>

          {/* Actions */}
          <div className="popover-footer">
            <button
              className="btn-back"
              onClick={() => setShowInviteAlert(false)}
            >
              Back
            </button>
            <button
              className="btn-continue"
              onClick={() => handleFinalSubmit()}
              disabled={!ageConfirmed}
              style={{ opacity: ageConfirmed ? 1 : 0.5 }}
            >
              Continue
            </button>
          </div>
        </div>
      </IonPopover>
    </form>
  );
};

const Signup2 = () => {
  const { i18n, t } = useTranslation();
  return (
    <IonPage>
      <LandingHeader />

      <IonContent fullscreen className="auth-content">
        <div className="auth-wrapper">
          {/* hero  */}
          <img
            src="/landing-page-banner.svg"
            alt="hero"
            className="landing-page-banner hide-on-mobile"
          />
          <div className="auth-hero auth-hero-2">
            <div className="show-on-mobile">
              <h2 className="auth-signin-header poetsen">{t("signup2")}</h2>
            </div>
            <div className="auth-main-container">
              <div className="auth-left-column hide-on-mobile">
                <div className="auth-text-wrapper">
                  <h1 className="auth-hero-title">{t("signup3.heroTitle")}</h1>
                  <p className="auth-hero-description">
                    {t("signup3.heroDescription")}
                    <br />
                    {t("signup3.heroDescription2")}
                  </p>
                  <p className="auth-hero-features">
                    <span>
                      <FaCheck /> {t("signup3.features.local")}{" "}
                      <FaCanadianMapleLeaf />
                    </span>
                    <span>
                      <FaCheck /> {t("signup3.features.rides")} 🚗
                    </span>
                    <span>
                      <FaCheck /> {t("signup3.features.early")} ⭐
                    </span>
                  </p>
                </div>
              </div>
              <div className="auth-form-box">
                <h2 className="auth-signin-header hide-on-mobile poetsen">
                  {t("signup2")}
                </h2>
                <SignupForm />
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Signup2;
